<template>
    <div class='news-bg'>
    <div class="all-news">
        <h2 class="page-title">所有最新消息</h2>
        <div class="news-grid">
            <div v-for="news in paginatedNews" :key="news.id" class="news-item" @click="goNewsDetail(news)">
                <div class="card-image-container2">
                <img :src="getFullImageURL(news.news_image)" :alt="news.title" class="card-image2"
                    @error="onImageError" />
                </div>                    
                <div class="item-text-bold news-date">{{ formatISODateToCustom(news.updated_at) }}</div>
                <div class="item-text-bold news-title"><NewsTitle :title="news.title" /></div>
            </div>
        </div>

        <!-- Use the Pagination component -->
        <Pagination :total="totalItems" :current="currentPage" :perPage="itemsPerPage"
            @page-changed="onPageChanged" />
    </div>
</div>    
</template>

<script>
import { onImageError, getFullImageURL, formatISODateToCustom, logNewsClick } from '@/util/util';
import PullDAO from '@/services/PullDAO';
import { globalParams } from '@/global';
import Pagination from '@/components/ThePagination.vue'; // Adjust the path as necessary
import NewsTitle from '@/components/home/NewsTitle.vue';

export default {
    name: 'AllNews',
    components: {
        Pagination,
        NewsTitle,
    },
    data() {
        return {
            isLoading: false,
            error: null,
            itemsPerPage: 9, // Number of offers per page
            currentPage: 1,  // Current page
            totalItems: 0,   // Total number of promotions
            paginatedNews: [],
        };
    },
    computed: {

        totalPages() {
            return Math.ceil(this.allNewsItems.length / this.itemsPerPage);
        },
    },
    methods: {
        formatISODateToCustom,
        onImageError,
        getFullImageURL,

        async fetchAllNews() {
            this.isLoading = true;
            this.error = null;
            const pullDAO = new PullDAO();

            try {
                const resp = await pullDAO.listNews(this.itemsPerPage, this.currentPage);
                this.paginatedNews = resp.news;
                this.totalItems = resp.total; // Ensure your API returns this

            } catch (error) {
                this.error = error.message || '無法加載所有消息。';
            } finally {
                this.isLoading = false;
            }
        },
        goNewsDetail(news) {
            logNewsClick(news, 'all');
            globalParams.shownNews = news;
            globalParams.news_paginatedNews = this.paginatedNews;
            globalParams.news_currentPage = this.currentPage;
            globalParams.news_totalItems = this.totalItems;

            this.$router.push("/news-detail");
        },
        onPageChanged(newPage) {
            this.currentPage = newPage;
            this.fetchAllNews();
        },
    },
    mounted() {
        if (globalParams.news_paginatedNews) {
            this.paginatedNews = globalParams.news_paginatedNews;
            this.currentPage = globalParams.news_currentPage;
            this.totalItems = globalParams.news_totalItems;
        } else {


            this.fetchAllNews();
        }
    },
};
</script>

<style scoped>

.news-bg {
    background-color: var(--background-gray);
    /* width:343px; */
}

.all-news {
    display: flex;
    flex-direction: column;
    width: var(--home-component-width);
    margin: 0 auto;
    text-align: center;

 
}



.news-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 30px;
    /* margin:0, auto; */
}

.news-item {
    background-color: bar(--background-gray);
    overflow: hidden;
    border-radius: 15px;
    /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */

    display: flex ;
    flex-direction: column;
    align-items: flex-start;
}

.news-title {
    margin: 4px 0;
    color: var(--gray15);
}

.news-date {
    margin-bottom: 0px;
}



/* Remove old pagination styles if any */
.pagination {
    display: none;
}

/* RWD样式 */
@media (max-width: 560px) {

    .all-news {
        width: 343px;
    }

    .news-grid {
        display:flex;
        flex-direction: column;
        justify-content: center;
        /* grid-template-columns: 1fr; */
        gap: 40px;
        align-items: center;
    }


    

    .news-item {
        width: 343px;
    }


}
</style>